import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function CTAButton({
  text = 'SÍ, QUIERO MI LIBERTAD AHORA',
  className = '',
  scrollTo,
  href
}: {
  text?: string;
  className?: string;
  scrollTo?: string;
  href?: string;
}) {
  const handleClick = () => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`w-full sm:w-auto px-8 py-4 bg-brand-amber hover:bg-brand-amberHover text-brand-darker font-bold text-sm md:text-base rounded-full uppercase tracking-wider shadow-[0_0_20px_rgba(212,165,116,0.2)] hover:shadow-[0_0_30px_rgba(212,165,116,0.4)] transition-all flex items-center justify-center gap-3 ${className}`} data-id="element-186">
      {text}
      <ArrowRight className="w-5 h-5" data-id="element-187" />
    </motion.button>;
}